import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let inflight = null;

export const prefetchRoles = () => {
  if (cache || inflight) return inflight || Promise.resolve(cache);
  inflight = axios.get(`${API}/roles`).then((r) => { cache = r.data; return cache; }).catch(() => []).finally(() => { inflight = null; });
  return inflight;
};

export const getCachedRoles = () => cache;
export const refreshRoles = () => { cache = null; return prefetchRoles(); };
